import { Component, inject, OnInit, signal } from '@angular/core';
import { BoardService } from '../board.service';
import { Board } from '@shared/entities/board';
import { PageHeaderComponent } from '@shared/components/page-header/page-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-board-list',
  templateUrl: './board-list.component.html',
  imports: [
    PageHeaderComponent,
    TranslateModule,
    MatCardModule,
    MatIconModule,
  ],
})
export class BoardListComponent implements OnInit {
  serverUrl = inject<string>('SERVER_URL' as any);
  private boardService = inject(BoardService);

  public leadingBoard = signal<Board[]>([]);
  public nonLeadingBoard = signal<Board[]>([]);

  constructor() {}

  ngOnInit(): void {
    this.boardService.getLeadingBoard().subscribe(boardMembers => {
      this.leadingBoard.set(this.boardMembersMap(boardMembers));
    });

    this.boardService.getNonLeadingBoard().subscribe(boardMembers => {
      this.nonLeadingBoard.set(this.boardMembersMap(boardMembers));
    });
  }

  boardMembersMap(boardMembers: Board[]): Board[] {
    boardMembers.forEach(member => {
      if (member.person) {
        if (member.person.title) {
          member.fullname =
            member.person.title + ' ' + member.person.firstname + ' ' + member.person.name;
        } else {
          member.fullname = member.person.firstname + ' ' + member.person.name;
        }
      }
    });
    return boardMembers;
  }
}
